import { useEffect } from 'react';
import { useLingui } from '@lingui/react';
import { BenefitsList } from './BenefitsList';
import { useCarleadDataLayer } from '../../../hooks/useCarleadDataLayer';
import { useTrackCustomerBanner } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SelfEvaluationCompleted() {
  const {
    i18n: _i18n
  } = useLingui();
  const dataLayer = useCarleadDataLayer();
  const {
    trackShownEvent
  } = useTrackCustomerBanner();
  const benefitsTranslations = ['carleadCreation.selfEvaluationCompletedRCB.benefitsList.first', 'carleadCreation.selfEvaluationCompletedRCB.benefitsList.second', 'carleadCreation.selfEvaluationCompletedRCB.benefitsList.third'];
  useEffect(() => {
    dataLayer.pushCustomerBannerOpen('self-evaluation-completed');
    trackShownEvent('self-evaluation-completed');
  }, [dataLayer, trackShownEvent]);
  return /*#__PURE__*/_jsx("div", {
    className: "container self-evaluation-completed-rcb",
    children: /*#__PURE__*/_jsxs("div", {
      className: "row self-evaluation-completed-rcb",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "col-md-6 col-sm-12",
        children: [/*#__PURE__*/_jsx("span", {
          className: "self-evaluation-completed-rcb__title",
          children: _i18n._('carleadCreation.selfEvaluationCompletedRCB.title')
        }), /*#__PURE__*/_jsx("p", {
          className: "self-evaluation-completed-rcb__text",
          children: _i18n._('carleadCreation.selfEvaluationCompletedRCB.text')
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "d-none d-md-block col-sm-6",
        children: /*#__PURE__*/_jsx(BenefitsList, {
          benefitsTranslations: benefitsTranslations
        })
      })]
    })
  });
}